import { Params } from '@angular/router';

export interface NavigationItem {
  id: string;
  name: string;
  selected?: boolean;
  icon?: string;
  route: string;
  query?: Params | null;
  appliesTo?: string[];
  children?: NavigationItem[];
}

/**
 * Navigation Child Identifier
 * Used to identify the child route of the parent route
 */
export enum NavigationChildIdentifier {
  // Settings
  Welcome = 'welcome',
  PersonalDetails = 'personal-details',
  OrganizationData = 'organization-data',
  UpdateOrganizationData = 'update-organization-data',
  Newsletter = 'newsletter',
  ChangePassword = 'change-password',
  ChangeEmail = 'change-email',
  DeactiveAccount = 'deactive-account',

  // Management
  RequestTiesAccess = 'request-ties-access',
  RequestNewAffiliation = 'request-new-affiliation',
  MyRequests = 'my-request',
  MyNonMemberRequests = 'my-non-member-requests',
  MyLiteUserRequests = 'my-lite-user-requests',

  // Focal Point
  AffiliationRequest = 'affiliation-request',
  TiesUserRequest = 'ties-user-request',
  ManageMembers = 'manage-members',
  ManageTiesUsers = 'manage-ties-users',
  ChangeFocalPoint = 'change-focal-point',

  // Ties Settings
  TiesUserProfile = 'ties-user-profile',
  TiesNotification = 'ties-notification',
}
